export enum FilterSelectGroup {
  SELECTED = 'Selected',
  SUGGESTED = 'Suggested',
  OTHER = 'Other',
}
